/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

export const toNumericViewId = (value: unknown): number | null => {
    if (value === null || value === undefined || value === '') {
        return null
    }

    const numericId = Number(value)
    return Number.isFinite(numericId) ? numericId : null
}
